<template>
  <div class="customFieldLabelAndValue">
    <div class="custom-field-label" v-if="customField.show_label">
      {{ customField.label }}
    </div>
    <div class="custom-field-value-string">
      <custom-field-value-string :value="value" :custom-field="customField" />
    </div>
  </div>
</template>

<script>
import CustomFieldValueString from './CustomFieldValueString'

export default {
  components: {
    CustomFieldValueString
  },
  props: {
    value: String,
    customField: Object
  }
}
</script>

<style lang="scss">
@import "../../style/settings";

.customFieldLabelAndValue {
  .custom-field-label {
    font-size: rem-calc(12);
    color: $muted-font-color;
    padding-bottom: 0.1em;
  }
  .custom-field-value-string {
    margin-bottom: 1em;
  }
}
</style>
